import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { SharedModule } from '@app/shared/shared.module';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { EventManager } from '@app/shared/utils/event-manager';

@Component({
  selector: 'slotcom-tournament-info',
  templateUrl: './tournament-info.component.html',
  styleUrls: ['./tournament-info.component.scss'],
  standalone: true,
  imports: [ParagraphComponent, SharedModule],
})
export class TournamentInfoComponent implements OnInit {
  tournamentInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private assetsService = inject(AssetsService);
  private gamesRepo = inject(GamesRepository);

  gameId: string;
  gameIcon: unknown;
  gameName: string;

  ngOnInit(): void {
    this.gameId = this.tournamentInfoModalData.data.liveOpsStatus.challengeStatus.gameId;

    if (this.gameId) {
      this.gameIcon = {
        'background-image': `url('${this.assetsService.getGameIconUrl(this.gameId)}')`,
      };

      this.gameName = this.gamesRepo.getGameById(this.gameId)?.gameTitle;
    }
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.tournamentInfoModalData.id, ModalType.View, this.tournamentInfoModalData)
    );
  }
}
